var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-tabs',[_c('a-tab-pane',{key:"baoy",attrs:{"tab":"保养标准"}}),_c('a-tab-pane',{key:"bpbj",attrs:{"tab":"备品备件"}},[_vm._v("2")]),_c('a-tab-pane',{key:"doc",attrs:{"tab":"手册资料"}},[_vm._v("3")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }